import { css, etiColors } from '@eti/styles';
import ExpandContent from './ExpandContent';
import LccInformation from './ReceiptLccInformation';

const containerStyles = css`
  border-top: 1px dotted ${etiColors.grayScale[8]};
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
`;

interface ReceiptSystemLCCProps {
  contentLCC: string;
  hideInfoLabel: string;
  showInfoLabel: string;
}

const ReceiptSystemLCC = ({ contentLCC, hideInfoLabel, showInfoLabel }: ReceiptSystemLCCProps) => (
  <div className={containerStyles}>
    <ExpandContent
      buttonDataTestId="order-lccinfo-toggle"
      label={showInfoLabel}
      labelHide={hideInfoLabel}
    >
      {({ isExpanded }) => <LccInformation content={contentLCC} isExpanded={isExpanded} />}
    </ExpandContent>
  </div>
);

export default ReceiptSystemLCC;
